const TransparentLayout = ({ children }) => <>{children}</>;

export default TransparentLayout;
